import Button from '../../../common/components/button/button';
import { useSimulation } from '../contexts/simulation';

import '../styles/simulation-banner.css';

export default function SimulationBanner() {
    const { overrides, resetAll } = useSimulation();
    if (overrides.size === 0) {
        return (
            <p className="simulation-banner simulation-banner--idle">
                Pausar o habilitar aquí es una <strong>simulación local</strong>: cambia solo esta vista y se descarta al salir.
            </p>
        );
    }
    return (
        <div className="simulation-banner simulation-banner--active" role="status">
            <p>
                <strong>Simulación local activa</strong> en {overrides.size} {overrides.size === 1 ? 'agente' : 'agentes'}.
                Ninguna orden se envió a Core.
            </p>
            <Button size="small" variant="secondary" onClick={resetAll}>Deshacer todo</Button>
        </div>
    );
}
